"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LlmResponseError = exports.ABORT_USER = void 0;
exports.getPromptResponse = getPromptResponse;
exports.getPromptStreamResponse = getPromptStreamResponse;
exports.getPromptData = getPromptData;
exports.getModalDataRequestBody = getModalDataRequestBody;
exports.ABORT_USER = 'user';
// Chyba AI vrácená backendem (vyčerpaný rozpočet, AI nenastavená…) – text je hláška pro uživatele
class LlmResponseError extends Error {
}
exports.LlmResponseError = LlmResponseError;
function rejectIfNotOk(response) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!response.ok) {
            throw new LlmResponseError(yield response.text());
        }
        return response;
    });
}
function getPromptResponse(body) {
    const abortController = new AbortController();
    const promise = new Promise((resolve, reject) => {
        fetch('llm/prompt-action', {
            method: 'POST',
            body: JSON.stringify(body),
            signal: abortController.signal,
        })
            .then(rejectIfNotOk)
            .then((res) => res.json())
            .then((res) => {
            resolve(res.value);
        })
            .catch((reason) => {
            reject(reason);
        });
    });
    return { promise, abort: (reason) => abortController.abort(reason !== null && reason !== void 0 ? reason : exports.ABORT_USER) };
}
function getPromptStreamResponse(body, chunkCallback) {
    const abortController = new AbortController();
    const promise = new Promise((resolve, reject) => {
        fetch('llm/prompt-stream-action?payload=' + encodeURIComponent(JSON.stringify(body)), {
            method: 'GET', // use GET because bunny CDN is retarded and does not support streaming over POST
            signal: abortController.signal,
        })
            .then(rejectIfNotOk)
            .then((response) => __awaiter(this, void 0, void 0, function* () {
            if (!response.body) {
                reject();
                return;
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let responseText = '';
            // eslint-disable-next-line no-constant-condition
            while (true) {
                const { done, value } = yield reader.read();
                if (done)
                    break;
                const chunk = decoder.decode(value, { stream: true });
                responseText += chunk;
                chunkCallback(responseText);
            }
            resolve();
        }))
            .catch((reason) => {
            reject(reason);
        });
    });
    return { promise, abort: () => abortController.abort(exports.ABORT_USER) };
}
function getPromptData(body) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            fetch('llm/modal-data', {
                method: 'POST',
                body: JSON.stringify(body),
            })
                .then((response) => response.json())
                .then((value) => resolve(value))
                .catch(() => reject());
        });
    });
}
function getModalDataRequestBody(state) {
    return {
        promptId: state.promptId,
        objectLabel: state.objectLabel,
        entityType: state.entityType,
        entityId: state.entityId,
        text: state.targetContent,
    };
}
